import api from 'api/base';
import { AxiosResponse } from 'axios';
import {
  AdminUserResponse,
  AuthMethodsResponse,
  CreateAdminRequest,
  GetUsersListResponse,
  UpdateAdminRequest,
} from 'features/admin-users/api/types';

export const getUsersList = async (params: {
  page: number;
  limit: number;
  selectedRole?: number;
  search?: string;
}): Promise<AxiosResponse<GetUsersListResponse>> => {
  return api.get<GetUsersListResponse>('/admin/account', {
    params,
  });
};

export const createAdminUser = async (
  data: CreateAdminRequest
): Promise<AxiosResponse<AdminUserResponse>> => {
  return api.post<AdminUserResponse>('/admin/account', data);
};

export const getAdminUser = async ({
  userId,
}: {
  userId: number;
}): Promise<AxiosResponse<AdminUserResponse>> => {
  return api.get<AdminUserResponse>(`/admin/account/${userId}`);
};

export const updateAdminUser = async ({
  data,
  userId,
}: {
  data: UpdateAdminRequest;
  userId: number;
}): Promise<AxiosResponse<AdminUserResponse>> => {
  return api.post<AdminUserResponse>(`/admin/account/update/${userId}`, data);
};

export const deleteAdminUser = async ({
  userId,
}: {
  userId: number;
}): Promise<number> => {
  await api.post(`/admin/account/delete/${userId}`);
  return userId;
};

export const deleteAdminUsers = async (
  userIds: number[]
): Promise<number[]> => {
  await api.post(`/admin/account/delete-many`, { userIds });
  return userIds;
};

export const getAuthMethods = async (
  partnerName: string
): Promise<AxiosResponse<AuthMethodsResponse>> => {
  return api.get<AuthMethodsResponse>(`admin/auth-methods/${partnerName}`);
};
